var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77767E"
    },
    d: "M498.685,171.94L203.006,1.228c-2.488-1.437-4.743-1.57-6.372-0.624l-4.155,2.415 c0.005-0.003,0.01-0.005,0.016-0.008c-1.616,0.931-2.621,2.92-2.629,5.754l-0.565,199.472c-0.016,5.636,3.916,12.49,8.805,15.387 c-4.965-2.7-12.747-2.654-17.571,0.149L8.07,324c-2.448,1.423-3.67,3.286-3.668,5.152c0-0.006-0.001-0.013-0.001-0.018l-0.014,4.805 c-0.005,1.884,1.238,3.771,3.728,5.208l295.68,170.71c4.948,2.857,12.941,2.857,17.854,0.001l172.466-100.226 c2.442-1.419,3.664-3.276,3.67-5.136l0.014-4.805c0,0.054-0.005,0.108-0.007,0.162c0.076-1.872-1.083-3.761-3.474-5.22 c2.397,1.259,4.551,1.294,6.1,0.311c-0.046,0.029-0.09,0.061-0.137,0.088l4.155-2.415c1.607-0.934,2.604-2.921,2.612-5.743 l0.565-199.472C507.629,181.719,503.634,174.796,498.685,171.94z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACABB1"
    },
    d: "M192.48,3.019l4.155-2.415c1.628-0.947,3.883-0.813,6.372,0.624l-4.155,2.415 C196.363,2.206,194.108,2.073,192.48,3.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57565C"
    },
    d: "M504.436,392.619l-4.155,2.415c1.607-0.934,2.604-2.921,2.612-5.743l4.155-2.415 C507.04,389.698,506.043,391.685,504.436,392.619z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77767E"
    },
    points: "503.459,189.819 507.614,187.404 507.048,386.876 502.894,389.291  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6C5CB"
    },
    points: "198.85,3.643 203.006,1.228 498.685,171.94 494.53,174.353  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACABB1"
    },
    d: "M494.53,174.353l4.155-2.415c4.948,2.857,8.944,9.779,8.929,15.464l-4.155,2.415 C503.475,184.133,499.478,177.21,494.53,174.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898890"
    },
    d: "M494.53,174.353c4.948,2.857,8.944,9.779,8.929,15.464l-0.565,199.472 c-0.016,5.683-4.039,7.975-8.987,5.118l-295.68-170.709c-4.946-2.856-8.942-9.777-8.926-15.46l0.565-199.472 c0.017-5.685,4.039-7.978,8.984-5.123L494.53,174.353z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C5CB"
    },
    d: "M4.389,333.938l0.014-4.805c-0.005,1.884,1.238,3.771,3.728,5.208l-0.014,4.805 C5.627,337.71,4.383,335.822,4.389,333.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57565C"
    },
    d: "M497.8,399.693l-0.014,4.805c-0.005,1.86-1.228,3.717-3.67,5.136l0.014-4.805 C496.572,403.409,497.795,401.552,497.8,399.693z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77767E"
    },
    points: "494.13,404.829 494.117,409.633 321.651,509.86 321.665,505.054  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#898890"
    },
    points: "303.81,505.053 303.797,509.858 8.117,339.147 8.13,334.342  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57565C"
    },
    d: "M321.665,505.054l-0.014,4.805c-4.913,2.856-12.907,2.856-17.854-0.001l0.014-4.805 C308.758,507.909,316.751,507.909,321.665,505.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACABB1"
    },
    d: "M494.072,394.485c4.948,2.857,4.974,7.487,0.059,10.343L321.665,505.054 c-4.913,2.856-12.907,2.856-17.854-0.001L8.13,334.342c-4.948-2.857-4.974-7.487-0.061-10.342l172.465-100.226 c4.916-2.857,12.909-2.857,17.857,0L494.072,394.485z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "485.429,193.502 207.662,33.133 207.177,204.218 484.945,364.586 485.429,193.502  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "279.751,411.16 226.429,380.375 207.671,391.276 260.993,422.061 279.751,411.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "203.823,260.274 178.555,245.686 159.797,256.588 185.064,271.176 203.823,260.274  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "231.878,276.472 206.61,261.884 187.852,272.785 213.119,287.373 231.878,276.472  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "259.934,292.67 234.664,278.081 215.906,288.983 241.176,303.572 259.934,292.67  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "287.989,308.868 262.722,294.28 243.963,305.181 269.231,319.769 287.989,308.868  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "316.043,325.065 290.776,310.477 272.017,321.379 297.285,335.967 316.043,325.065  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "344.1,341.263 318.833,326.675 300.075,337.577 325.342,352.165 344.1,341.263  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "372.154,357.461 346.887,342.873 328.129,353.775 353.396,368.362 372.154,357.461  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "400.212,373.659 374.942,359.07 356.184,369.972 381.453,384.561 400.212,373.659  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "428.266,389.857 402.999,375.269 384.24,386.17 409.507,400.758 428.266,389.857  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "456.323,406.055 431.054,391.466 412.295,402.368 437.565,416.957 456.323,406.055  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "176.001,276.443 150.734,261.855 131.978,272.756 157.245,287.342 176.001,276.443  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "204.055,292.64 178.788,278.052 160.032,288.953 185.299,303.54 204.055,292.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "232.112,308.839 206.843,294.25 188.087,305.149 213.356,319.738 232.112,308.839  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "260.166,325.036 234.899,310.448 216.143,321.349 241.41,335.936 260.166,325.036  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "288.221,341.234 262.954,326.646 244.198,337.545 269.465,352.133 288.221,341.234  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "316.278,357.432 291.01,342.844 272.255,353.745 297.522,368.332 316.278,357.432  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "344.333,373.63 319.065,359.042 300.309,369.941 325.577,384.529 344.333,373.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "372.389,389.828 347.119,375.239 328.363,386.138 353.633,400.728 372.389,389.828  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "400.444,406.025 375.177,391.437 356.421,402.338 381.688,416.925 400.444,406.025  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "428.5,422.224 403.231,407.635 384.476,418.534 409.744,433.123 428.5,422.224  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "154.473,288.954 129.206,274.366 110.45,285.266 135.717,299.854 154.473,288.954  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "182.527,305.151 157.26,290.563 138.504,301.463 163.771,316.051 182.527,305.151  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "210.584,321.35 185.315,306.761 166.559,317.66 191.828,332.25 210.584,321.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "238.638,337.547 213.371,322.959 194.615,333.859 219.882,348.447 238.638,337.547  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "266.693,353.745 241.426,339.157 222.67,350.056 247.937,364.644 266.693,353.745  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "294.75,369.943 269.483,355.355 250.728,366.255 275.994,380.843 294.75,369.943  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "350.861,402.339 325.591,387.75 306.835,398.649 332.105,413.239 350.861,402.339  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "378.916,418.537 353.649,403.949 334.893,414.848 360.16,429.436 378.916,418.537  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "406.972,434.735 381.703,420.146 362.947,431.045 388.216,445.635 406.972,434.735  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "132.947,301.463 107.68,286.875 88.922,297.777 114.189,312.364 132.947,301.463  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "161.001,317.66 135.734,303.072 116.976,313.974 142.243,328.561 161.001,317.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "189.059,333.859 163.789,319.269 145.031,330.171 170.3,344.761 189.059,333.859  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "217.113,350.056 191.846,335.468 173.087,346.37 198.354,360.957 217.113,350.056  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "245.168,366.253 219.901,351.665 201.142,362.567 226.409,377.154 245.168,366.253  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "273.224,382.452 247.958,367.864 229.2,378.766 254.466,393.353 273.224,382.452  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "167.531,346.37 142.261,331.781 123.503,342.681 148.773,357.271 167.531,346.37  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "195.585,362.567 170.318,347.979 151.559,358.88 176.826,373.468 195.585,362.567  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "223.64,378.764 198.373,364.176 179.614,375.077 204.882,389.665 223.64,378.764  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "335.863,443.556 310.596,428.968 291.837,439.869 317.104,454.457 335.863,443.556  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "89.892,326.484 64.624,311.896 45.869,322.796 71.136,337.384 89.892,326.484  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "117.946,342.681 92.678,328.093 73.922,338.994 99.19,353.582 117.946,342.681  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "258.223,423.67 232.956,409.083 214.2,419.983 239.467,434.571 258.223,423.67  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "230.168,407.473 120.733,344.291 101.978,355.191 211.412,418.374 230.168,407.473  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "286.28,439.869 261.01,425.28 242.254,436.18 267.524,450.77 286.28,439.869  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "314.335,456.066 289.068,441.478 270.312,452.379 295.579,466.967 314.335,456.066  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "342.391,472.265 317.122,457.676 298.367,468.576 323.635,483.165 342.391,472.265  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "322.805,386.141 297.538,371.553 257.254,394.963 282.521,409.55 322.805,386.141  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E2E30"
    },
    points: "139.474,330.171 86.152,299.386 67.394,310.287 120.715,341.072 139.474,330.171  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.e915741e283c8f2a52f4652efcd13ca1.svg";
export { ForwardRef as ReactComponent };